<template>
  <div id="tab"
       ref="tab">
    <treeGrid ref="treeGrid"
              sum-text="sum"
              index-text="#"
              :data="data"
              :columns="columns"
              :stripe="props.stripe"
              :border="props.border"
              :show-header="props.showHeader"
              :show-summary="props.showSummary"
              :show-row-hover="props.showRowHover"
              :show-index="props.showIndex"
              :tree-type="props.treeType"
              :empty-text="'No Data'"
              :is-fold="props.isFold"
              :expand-type="props.expandType"
              :selection-type="props.selectionType">
      <template #add="scope">
        <div class="cursor-pointer"
             @click="showModal(scope.row)"
             v-b-modal.new-step>
          <b-icon scale="2"
                  variant="secondary"
                  icon="plus-square-fill"
                  sm/>
        </div>
      </template>
      <template #del="scope">
        <div class="cursor-pointer"
             @click="deleteChild(scope.row)">
          <b-icon scale="2"
                  variant="secondary"
                  icon="dash-square-fill"
                  sm/>
        </div>
      </template>
    </treeGrid>

    <!-- Lv 1 creation button -->
    <esg-base-button variant="primary"
                     class="mt-3"
                     size="sm"
                     style="width: 100px"
                     @click="showModal(null)">추가
    </esg-base-button>
    <!-- /Lv 1 creation button -->

    <!-- New content creation modal -->
    <b-modal ref="newStepModal"
             id="new-step"
             :hide-header="true"
             :hide-footer="true"
             size="md">
      <div style="padding : 1em;">
        <b-form-row>
          <b-col>
            <label for="step">목차</label>
            <b-input id="step"
                     size="sm"
                     class="custom-input"
                     v-model="newStep.label"/>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <label for="description">설명</label>
            <b-form-input id="description"
                          name="description"
                          size="sm"
                          class="custom-input rounded"
                          v-model="newStep.description"></b-form-input>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col>
            <label for="gri">GRI</label>
            <b-form-group id="gri">
              <b-form-select v-model="newStep.griLv1"
                             class="mt-1">
                <option v-for="option in getGriOptions(1)"
                        :key="option"
                        :value="option">
                  {{ option }}
                </option>
              </b-form-select>
              <b-form-select v-if="newStep.griLv1"
                             v-model="newStep.griLv2"
                             class="mt-1">
                <option v-for="option in getGriOptions(2)"
                        :key="option">
                  {{ option }}
                </option>
              </b-form-select>
              <b-form-select v-if="newStep.griLv2"
                             v-model="newStep.griLv3"
                             class="mt-1">
                <option v-for="option in getGriOptions(3)"
                        :key="option"
                        :value="option">
                  {{ option }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-form-row>
      </div>
      <esg-base-button variant="primary"
                       @click="addChild()">생성
      </esg-base-button>
    </b-modal>
    <!-- New content creation modal -->
  </div>
</template>
<script>
import treeGrid from 'vue-table-with-tree-grid'
import griData from '../model/gri.json'
import EsgBaseButton from "@/components/esg/base/EsgBaseButton.vue";
import { v4 as uuid } from "uuid"

export default {
  name: "EsgTocTemplateManagementGrid",
  props: {
    data: {
      type: Array,
      required: true,
    },
    deletedItems: {
      type: Array,
      required: false
    }
  },
  components: {
    EsgBaseButton,
    treeGrid
  },
  data() {
    return {
      props: {
        stripe: false,
        border: false,
        showHeader: true,
        showSummary: false,
        showRowHover: true,
        showIndex: false,
        treeType: true,
        isFold: false,
        expandType: false,
        selectionType: false,
      },
      newStep: {},
      columns: [
        {
          label: "목차",
          prop: "label",
          width: "350rem",
          headerAlign: "center",
        },
        {
          label: "",
          width: "30rem",
          type: "template",
          template: "add",
          headerAlign: "center",
          align: "center"
        },
        {
          label: "",
          width: "30rem",
          type: "template",
          template: "del",
          headerAlign: "center",
          align: "left"
        },
        {
          label: "ESG",
          width: "100rem",
          prop: "griLv1",
          headerAlign: "center",
          align: "center"
        },
        {
          label: "GRI 공시 기준",
          width: "250rem",
          prop: "griLv2",
          headerAlign: "center",
          align: "left"
        },
        {
          label: "GRI 세부지표",
          width: "250rem",
          prop: "griLv3",
          headerAlign: "center",
          align: "left"
        },
        {
          label: "설명",
          width: "300rem",
          prop: "description",
          headerAlign: "center",
          align: "left"
        }
      ],
      componentKey: 'No Data',
    };
  },
  methods: {
    generateId() {
      return uuid();
    },
    showModal(obj) {
      this.newStep = {
        id: this.generateId(),
        label: '',
        parent: obj,
        description: '',
        order: null,
        griLv1: '',
        griLv2: '',
        griLv3: '',
        children: [],
        created: true,
        updated: false,
      }
      this.$refs['newStepModal'].show();
    },
    addChild() {
      this.$refs['newStepModal'].hide();
      const parent = this.newStep.parent;
      if (parent) {
        parent.children.push(this.newStep);
      } else {
        this.data.push(this.newStep);
      }
    },
    deleteChild(target) {
      // If the target node has a parent, we are in a nested structure.
      if (target.parent) {
        // Get the array of children from the parent of the target node.
        const children = target.parent.children;
        // Find the index of the target node in its parent's children array.
        const indexToRemove = children.findIndex(child => child.id === target.id);
        // Add the ID of the target node to an array tracking deleted nodes.
        this.deletedItems && this.deletedItems.push(children[indexToRemove].id);
        // Remove the target node from its parent's children array.
        children.splice(indexToRemove, 1);
      }
      // If the target node doesn't have a direct parent but has a parentId,
      // it means the parent needs to be found in the larger data structure.
      else if (target.parentId) {
        // Find the parent node using the parentId in the overall data structure.
        const parent = this.findById(this.data, target.parentId);
        // Find the index of the target node in the parent's children array.
        const indexToRemove = parent.children.findIndex(child => child.id === target.id);
        // Add the ID of the target node to an array tracking deleted nodes.
        this.deletedItems && this.deletedItems.push(parent.children[indexToRemove].id);
        // Remove the target node from the parent's children array.
        parent.children.splice(indexToRemove, 1);
      }
      // If the target node has neither a parent nor a parentId,
      // it is a top-level element in the data structure.
      else {
        // Find the index of the target node in the top-level data array.
        const indexToRemove = this.data.findIndex(child => child.id === target.id);
        // Add the ID of the target node to an array tracking deleted nodes.
        this.deletedItems && this.deletedItems.push(this.data[indexToRemove].id);
        // Remove the target node from the top-level data array.
        this.data.splice(indexToRemove, 1);
      }
    },
    findById(root, id) {
      if (!root) return null;
      let children = root;
      if (typeof root === 'object' && root.children) {
        if (root.id === id) return root;
        children = root.children;
      }
      for (const child of children) {
        const result = this.findById(child, id);
        if (result) return result;
      }
      return null;
    },
    getGriOptions(lv) {
      let tempData = griData;
      if (lv > 1) {
        let parentLv = 'griLv' + (lv - 1);
        tempData = tempData.filter(obj => obj[parentLv] === this.newStep[parentLv])
      }
      let targetLv = 'griLv' + lv;
      tempData = tempData.map(obj => obj[targetLv])
      return Array.from(new Set(tempData))
    },
  }
};
</script>

<style scoped>
>>> .btn {
  height: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
}

>>> .modal-dialog {
  margin: 0 auto;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

>>> .modal-body button {
  width: 100%;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

>>> .modal-body {
  padding: 0;
}

>>> .modal-content,
>>> .modal-body {
  border-radius: 10px;
}

>>> .modal-body .custom-select {
  -o-appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 0.533rem 0.8rem 0.533rem 1.066rem;
  height: 2.666rem;
  border-radius: 10px;
  border: 1px solid #E7E7EE;
  background-color: #F6F6FA;
  background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M15.834 7.5L10.0007 13.3333L4.16732 7.5" stroke="%232E2E38" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
  background-position: calc(100% - 12px) 9px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  font-family: 'NanumGothic';
  color: #2E2E38;
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
}

>>> .modal-body .custom-select {
  margin-bottom: 2rem;
}

>>> .modal-body .custom-select:last-of-type {
  margin-bottom: 0;
}

.cursor-pointer {
  cursor: pointer;
}
</style>
